
import newsList from '@/pagemixins/map/mapList';
export default {
  mixins: [newsList]
}
